// https://app.growthbook.io/features/pen-7584_v1
export const PROMO_BANNER_ALL_CLASSES_FLAG_NAME = 'pen-7584_v1'
